import createLucideIcon from '../createLucideIcon';

const Award = createLucideIcon('Award', [
  ['circle', { cx: '12', cy: '8', r: '6', key: '1vp47v' }],
  ['path', { d: 'M15.477 12.89 17 22l-5-3-5 3 1.523-9.11', key: 'em7aur' }],
]);

export default Award;
